import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR, FIXED_INDENTS } from 'vars/index'
import { Button } from '../Button'
import { ButtonColors, ButtonIconSizes, IconPositions } from '../Button.h'

export interface IInlinePrimaryBackSmallButtonProps extends IButtonProps {}

export const InlinePrimaryBackSmallButton = ({
  icon = IconNames.angleLeft,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.small,
  colorDefault = ButtonColors.COLOR_MAIN_DEFAULT,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  paddings = [FIXED_INDENTS.INDENT_30],
  ...rest
}: IInlinePrimaryBackSmallButtonProps): JSX.Element => (
  <Button
    icon={icon}
    iconPosition={iconPosition}
    iconSize={iconSize}
    colorDefault={colorDefault}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorDisabled={colorDisabled}
    backgroundColorDefault={backgroundColorDefault}
    backgroundColorDisabled={backgroundColorDisabled}
    paddings={paddings}
    {...rest}
  />
)
